<template>
  <div>
    <vs-card>
      <!-- <vs-button
       v-if="checkCertificateCreatePermission()"
              class="btnx"
              style="margin-right: 1%"
              @click="addRecord"
            >
              Create Certificate
    </vs-button> -->
    </vs-card>
    <div class="certificate_tab_holder">
      <div class="create_cert_btn_holder">
        <vs-button
          v-if="checkCertificateCreatePermission()"
          class="btnx"
          style="margin-right: 1%"
          @click="addRecord"
        >
          Create Certificate
        </vs-button>
      </div>
      <vs-tabs class="unique_cstm_tab" v-model="tabIndex">
        <vs-tab label="Certificate Templates">
          <vx-card title="Search View" class="mb-4">
            <div class="filter-holder">
              <div class="p-1 filter-holder-col">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="search"
                  @keyup="searchFun"
                  style="width: 100%"
                />
              </div>
              <div class="p-1 filter-holder-col">
                <v-select
                  placeholder="Filter Type"
                  appendToBody
                  v-model="certificate_type"
                  :options="certificateType"
                  :reduce="mode => mode.id"
                  label="value"
                  :clearable="false"
                ></v-select>
              </div>
              <div class="p-1 flex">
                <vs-tooltip text="Search">
                  <vs-button
                    @click="runFilter"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                  ></vs-button>
                </vs-tooltip>

                <vs-tooltip text="Reset">
                  <vs-button
                    @click="resetFilter"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
              </div>
            </div>
          </vx-card>
          <vs-card>
            <div class="text-right mb-2">
              <div
                v-if="isRowSelected"
                class="bulk_holder"
              >
                <a
                  v-if="
                    isRowSelected &&
                      checkCertificateDeletePermission
                  "
                  @click="bulkDelete"
                >
                  Bulk Delete
                </a>
              </div>
            </div>
            <ag-grid-vue
              ref="agGridTable"
              class="ag-theme-material w-100 my-4 ag-grid-table"
              :gridOptions="templateGridOptions"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              :rowData="rowDataTemplate"
              rowSelection="multiple"
              @row-selected="CellvalueSelectDeselect"
              :enableRtl="$vs.rtl"
              colResizeDefault="true"
              :style="{ minHeight: meta.limit * 48 + 75 + 'px' }"
              :animateRows="true"
              :floatingFilter="false"
              :pagination="true"
              :paginationPageSize="paginationPageSize"
              :suppressPaginationPanel="true"
              @grid-ready="onGridReady"
              @sortChanged="sortFun"
            >
            </ag-grid-vue>
            <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
              <vs-col
                vs-xs="12"
                vs-sm="6"
                vs-lg="4"
                vs-type="flex"
                vs-justify="start"
                vs-align="center"
              >
                <!-- page limit select view -->
                <ItemsPerTableDropdown
                  tableName="certificate_template"
                  @change="pageLimit => (pageLimitSet = pageLimit)"
                />
              </vs-col>
              <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
                <pagination
                  style="float: right"
                  :meta="meta"
                  @page-change="handlePageChange"
                />
              </vs-col>
            </vs-row>
            <!-- <vs-table class="cstm_vuexy_table" multiple v-model="selectedCertificateTemplate" :data="certificate_template">
              <template slot="thead">
                  <vs-th style="width: 240px;"> Certificate Name </vs-th>
                  <vs-th> Certificate Description </vs-th>
                  <vs-th style="text-align:center;width: 400px;"> Actions </vs-th>
              </template>
              <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].title">
                      {{ data[indextr].title }}
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                      {{ data[indextr].description }}
                  </vs-td>
                  <vs-td>
                      <div class="flex">
                        <vs-button class="mx-1" v-if="checkCertificateTemViewPermission()" icon-pack="feather" @click="preview(data[indextr])" icon="icon-eye"></vs-button>
                          <vs-button v-if="checkCertificateEditPermission()" class="mx-1" icon-pack="feather" @click="editTemplate(data[indextr])" icon="icon-edit"></vs-button>
                          <vs-button v-if="checkCertificateDeletePermission()" class="mx-1" color="danger" icon-pack="feather" icon="icon-trash" @click="openConfirm(data[indextr].certificate_template_id, 'single')"></vs-button>
                          <vs-button v-if="checkCertificateGeneratePermission()" class="mx-1" :disabled="data[indextr].type==1 || data[indextr].type==2" @click="generate(data[indextr])">Generate Certificate</vs-button>
                      </div>
                  </vs-td>
                  </vs-tr>
              </template>
              </vs-table> -->
          </vs-card>
        </vs-tab>

        <vs-tab label="Generated Certificate">
          <vx-card title="Search View" class="mb-4">
            <div class="filter-holder">
              <div class="p-1 filter-holder-col">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="searchGen"
                  @keyup="searchFunGen"
                  style="width: 100%"
                />
              </div>
              <div class="p-1 filter-holder-col">
                <v-select
                  placeholder="Filter Type"
                  appendToBody
                  v-model="filter.certificate_type"
                  :options="certificateType"
                  :reduce="mode => mode.id"
                  label="value"
                  :clearable="false"
                ></v-select>
              </div>

              <div class="p-1 filter-holder-col">
                <v-select
                  placeholder="Filter By Staff"
                  appendToBody
                  v-model="filter.teacher_id"
                  :options="userList"
                  :reduce="mode => mode.users_id"
                   @open="onOpenUser"
                  @close="onCloseUser"
                  :clearable="false"
                  :getOptionLabel="
                    item => `${item.first_name} ${item.last_name}`
                  "
                >
                  <template v-slot:selected-option="userList">
                    <img
                      v-if="userList.picture"
                      class="person-img rounded-full"
                      :src="userList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ userList.first_name }}
                    {{ userList.last_name }} </template
                  ><template v-slot:option="userList">
                    <img
                      v-if="userList.picture"
                      class="person-img rounded-full"
                      :src="userList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ userList.first_name }}
                    {{ userList.last_name }}
                  </template>
                   <template #list-footer>
                    <li
                      ref="load"
                      class="loader"
                      v-show="userListMeta.has_next"
                    >
                      Loading more staff...
                    </li>
                  </template>
                </v-select>
              </div>
              <div class="p-1 filter-holder-col">
                <v-select
                 @open="onOpenClient"
                  @close="onCloseClient"
                  placeholder="Filter By Client"
                  appendToBody
                  v-model="filter.student_id"
                  :options="clientList"
                  :reduce="mode => mode.client_users_id"
                  :getOptionLabel="
                    item => `${item.first_name} ${item.last_name}`
                  "
                  
                  :clearable="false"
                  
                >
                  <template v-slot:selected-option="clientList">
                    <img
                      v-if="clientList.picture"
                      class="person-img rounded-full"
                      :src="clientList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ clientList.first_name }}
                    {{ clientList.last_name }}
                  </template>
                  <template v-slot:option="clientList">
                    <img
                      v-if="clientList.picture"
                      class="person-img rounded-full"
                      :src="clientList.picture"
                    />
                    <img
                      v-else
                      class="person-img rounded-full"
                      src="@/assets/images/pages/user-circle-solid.svg"
                    />
                    {{ clientList.first_name }}
                    {{ clientList.last_name }}
                  </template>
                   <template #list-footer>
                    <li
                      ref="loadStudent"
                      class="loader"
                      v-show="clientListMeta.has_next"
                    >
                      Loading more clients...
                    </li>
                  </template>
                </v-select>
              </div>
              <div class="p-1 flex">
                <vs-tooltip text="Search">
                  <vs-button
                    @click="runFiltercer"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                  ></vs-button>
                </vs-tooltip>

                <vs-tooltip text="Reset">
                  <vs-button
                    @click="resetFiltercer"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
              </div>
            </div>
          </vx-card>
          <vs-card>
            <div class="text-right mb-2">
              <div v-if="selectedGenCertificate.length > 1" class="bulk_holder">
                <a
                  v-if="
                    selectedGenCertificate.length > 1 &&
                      checkCertificateDeletePermission()
                  "
                  @click="bulkDeleteGenerateCer"
                >
                  Bulk Delete
                </a>
                <a
                  v-if="
                    selectedGenCertificate.length > 1 &&
                      checkCertificateSharePermission()
                  "
                  @click="bulkShare"
                >
                  Bulk Share
                </a>
                <a v-if="selectedGenCertificate.length > 1" @click="bulkImg">
                  Bulk Download as Image
                </a>
                <a v-if="selectedGenCertificate.length > 1" @click="bulkPdf">
                  Bulk Download as PDF
                </a>
              </div>
            </div>
           <ag-grid-vue
              class="ag-theme-material w-100 my-4 ag-grid-table"
              :gridOptions="certificateGridOptions"
              :columnDefs="columnDefs1"
              :defaultColDef="defaultColDef"
              :rowData="generated_certificate"
              rowSelection="multiple"
              @row-selected="CellvalueSelectDeselect"
              :enableRtl="$vs.rtl"
              colResizeDefault="true"
              :style="{ minHeight: meta1.limit * 48 + 75 + 'px' }"
              :animateRows="true"
              :floatingFilter="false"
              :pagination="true"
              :paginationPageSize="paginationPageSizeGen"
              :suppressPaginationPanel="true"
              @grid-ready="onGridReady"
              @sortChanged="sortGenFun"
            >
            </ag-grid-vue>
            <vs-row class="mt-2" vs-type="flex" vs-justify="space-between">
              <vs-col
                vs-xs="12"
                vs-sm="6"
                vs-lg="4"
                vs-type="flex"
                vs-justify="start"
                vs-align="center"
              >
                <!-- page limit select view -->
                <ItemsPerTableDropdown
                  tableName="certificate_template"
                  @change="pageLimit => (pageLimitGen = pageLimit)"
                />
              </vs-col>
              <vs-col vs-xs="12" vs-sm="6" vs-lg="8">
                <pagination
                  style="float: right"
                  :meta="meta1"
                  @page-change="handlePageChangeCer"
                />
              </vs-col>
            </vs-row>
            </vs-card>
            <!-- <vs-table
              class="cstm_vuexy_table"
              multiple
              v-model="selectedGenCertificate"
              :data="generated_certificate"
            >
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">


                  <vs-td
                    :data="data[indextr].to_user_details"
                    v-for="name in data[indextr].to_user_details"
                    :key="name.client_main_id"
                  >
                    {{ name.first_name }} {{ name.last_name }}
                  </vs-td>

                  <vs-td>
                    <div class="flex">
                      <vs-button
                        class="mx-1"
                        v-if="checkCertificateGenerateViewPermission()"
                        icon-pack="feather"
                        @click="previewCertificate(data[indextr])"
                        icon="icon-eye"
                      ></vs-button>
                      <vs-button
                        class="mx-1"
                        v-if="data[indextr].is_shared == true"
                        color="primary"
                        disabled
                        icon="share"
                        >Shared</vs-button
                      >
                      <vs-button
                        class="mx-1"
                        v-if="
                          data[indextr].is_shared == false &&
                            checkCertificateSharePermission()
                        "
                        color="primary"
                        @click="share(data[indextr].certificate_id, 'single')"
                        icon="share"
                        >Share</vs-button
                      >
                      <vs-tooltip text="Download as Image"
                        ><vs-button
                          class="mx-1"
                          icon-pack="feather"
                          @click="
                            singleImageDownload(data[indextr].certificate_id)
                          "
                          icon="icon-image"
                        ></vs-button
                      ></vs-tooltip>
                      <vs-tooltip text="Download as PDF"
                        ><vs-button
                          class="includeIcon includeIconOnly mx-1"
                          @click="
                            singlePdfDownload(data[indextr].certificate_id)
                          "
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 30 30"
                            fill="none"
                          >
                            <path
                              d="M15.3717 4.37693C15.8237 4.58993 15.7297 4.86593 15.5907 6.16993C15.4487 7.51493 14.9727 9.97193 14.0557 12.3889C13.1377 14.8019 11.7757 17.1729 10.5887 18.9279C9.40273 20.6839 8.38773 21.8249 7.61373 22.4839C6.83673 23.1429 6.29973 23.3189 5.94873 23.3769C5.60073 23.4349 5.44273 23.3769 5.34873 23.1999C5.25473 23.0239 5.22173 22.7339 5.30273 22.3799C5.38173 22.0299 5.57073 21.6199 6.10673 21.0949C6.64773 20.5679 7.53273 19.9229 8.76773 19.3239C10.0027 18.7239 11.5847 18.1679 12.8837 17.7869C14.1827 17.4079 15.1947 17.2019 16.0807 17.0409C16.9687 16.8789 17.7277 16.7639 18.4717 16.7039C19.2157 16.6479 19.9457 16.6479 20.6577 16.7039C21.3697 16.7639 22.0657 16.8789 22.6687 17.0269C23.2687 17.1729 23.7767 17.3479 24.2197 17.6279C24.6617 17.9039 25.0427 18.2849 25.2317 18.7109C25.4237 19.1339 25.4237 19.6039 25.2647 19.9389C25.1067 20.2759 24.7887 20.4799 24.4257 20.5989C24.0617 20.7139 23.6507 20.7429 23.1587 20.5989C22.6687 20.4509 22.0967 20.1289 21.4967 19.7049C20.8957 19.2799 20.2617 18.7529 19.4397 17.9339C18.6157 17.1149 17.6017 16.0039 16.7477 14.9209C15.8937 13.8379 15.1947 12.7849 14.7197 11.8919C14.2467 10.9989 13.9927 10.2679 13.7867 9.53693C13.5807 8.80393 13.4227 8.07293 13.3597 7.41493C13.2967 6.75693 13.3257 6.16993 13.3897 5.70093C13.4527 5.23493 13.5497 4.88093 13.7067 4.64593C13.8647 4.41593 14.0877 4.29593 14.2457 4.23793C14.4037 4.17993 14.4997 4.17993 14.5937 4.16493C14.6877 4.14993 14.7817 4.12093 14.9267 4.16493C15.0647 4.20693 15.2477 4.31893 15.4307 4.43293"
                              stroke="#fff"
                              stroke-width="1.4"
                              stroke-miterlimit="10"
                              stroke-linejoin="round"
                            /></svg></vs-button
                      ></vs-tooltip>
                      <vs-button
                        class="mx-1"
                        v-if="certificategenerateDelete"
                        color="danger"
                        @click="
                          openConfirmForCertificate(
                            data[indextr].certificate_id,
                            'single'
                          )
                        "
                        icon-pack="feather"
                        icon="icon-trash"
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vs-card>
          <pagination
            :meta="meta1"
            @page-change="handlePageChangeCer"
            class="ml-auto"
          /> -->
        </vs-tab>
        <vs-tab v-if="staff" label="Shared Certificates">
          <vx-card title="Search View" class="mb-4">
            <div class="filter-holder">
              <div class="p-1 filter-holder-col">
                <vs-input
                  placeholder="Search"
                  class="w-full"
                  v-model="searchShare"
                  @keyup="searchFunshare"
                  style="width: 100%"
                />
              </div>
              <div class="p-1 filter-holder-col">
                <v-select
                  placeholder="Filter Course"
                  appendToBody
                  v-model="filterPayload.course_id"
                  :options="courseOpt"
                  :reduce="course => course.id"
                  label="name"
                  :clearable="false"
                  @open="onOpen"
                  @close="onClose"
                >
                  <template #list-footer>
                    <li
                      ref="load"
                      class="loader"
                      v-show="course_list_meta.has_next"
                    >
                      Loading more courses...
                    </li>
                  </template>
                </v-select>
              </div>
              <div class="p-1 filter-holder-col">
                <v-select
                  placeholder="Filter Type"
                  appendToBody
                  v-model="filterPayload.certificate_type"
                  :options="certificateType"
                  :reduce="mode => mode.id"
                  label="value"
                  :clearable="false"
                ></v-select>
              </div>
              <div class="p-1 filter-holder-col">
                <date-range-picker
                  ref="picker"
                  class="w-full"
                  :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY HH:mm:ss' }"
                  :showWeekNumbers="true"
                  :showDropdowns="true"
                  :autoApply="true"
                  v-model="dateRange"
                >
                  <template v-slot:input="picker" style="min-width: 350px">
                    <span
                      v-if="
                        dateRange.startDate === null ||
                          dateRange.endDate === null
                      "
                      style="color: rgba(0, 0, 0, 0.5); font-weight: 400; font-size: 12px;"
                      >Select Date Range</span
                    >
                    <span v-else
                      >{{ picker.startDate | moment("DD MMM") }} -
                      {{ picker.endDate | moment("DD MMM") }}</span
                    >
                  </template>
                </date-range-picker>
              </div>
              <div class="p-1 flex">
                <vs-tooltip text="Search">
                  <vs-button
                    @click="runFilterShare"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                  ></vs-button>
                </vs-tooltip>

                <vs-tooltip text="Reset">
                  <vs-button
                    @click="resetFilterShare"
                    type="border"
                    icon-pack="feather"
                    icon="icon-refresh-ccw"
                    class="ml-2"
                  ></vs-button>
                </vs-tooltip>
              </div>
            </div>
          </vx-card>
          <vs-card>
            <div class="text-right mb-2">
              <div class="bulk_holder">
                <a
                  v-if="selectedSharedCertificate.length > 1"
                  @click="bulkDeleteShare"
                >
                  Bulk Delete
                </a>
                <a v-if="selectedSharedCertificate.length > 1" @click="bulkImg">
                  Bulk Download as Image
                </a>
                <a v-if="selectedSharedCertificate.length > 1" @click="bulkPdf">
                  Bulk Download as Pdf
                </a>
              </div>
            </div>
            <vs-table
              multiple
              v-model="selectedSharedCertificate"
              :data="sharedList"
            >
              <template slot="thead">
                <vs-th style="width: 240px;"> Certificate Name </vs-th>
                <vs-th> Description </vs-th>
                <vs-th> Type </vs-th>
                <vs-th> Course </vs-th>
                <vs-th> School Name </vs-th>
                <vs-th> Issue Date </vs-th>
                <vs-th> Actions </vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].title">
                    {{ data[indextr].title }}
                  </vs-td>
                  <vs-td :data="data[indextr].description">
                    {{ data[indextr].description }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].certificate_type }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{
                      data[indextr].course_name != ""
                        ? data[indextr].course_name
                        : ""
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].type">
                    {{ data[indextr].customer_name }}
                  </vs-td>
                  <vs-td :data="data[indextr]">
                    {{ data[indextr].issue_date }}
                  </vs-td>
                  <vs-td>
                    <div class="flex">
                      <vs-button
                        class="mx-1"
                        icon-pack="feather"
                        @click="preview(data[indextr])"
                        icon="icon-eye"
                      ></vs-button>
                      <vs-tooltip text="Download as Image"
                        ><vs-button
                          class="mx-1"
                          icon-pack="feather"
                          @click="
                            singleImageDownload(data[indextr].certificate_id)
                          "
                          icon="icon-download"
                        ></vs-button
                      ></vs-tooltip>
                      <vs-tooltip text="Download as Pdf"
                        ><vs-button
                          class="mx-1"
                          icon-pack="feather"
                          @click="
                            singlePdfDownload(data[indextr].certificate_id)
                          "
                          icon="icon-download"
                        ></vs-button
                      ></vs-tooltip>
                      <!-- <vs-button class="mx-1" icon-pack="feather" icon="icon-download"></vs-button>
                        <vs-button class="mx-1" icon-pack="feather" icon="icon-download"></vs-button> -->
                      <vs-button
                        class="mx-1"
                        color="danger"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click="
                          openConfirmshared(
                            data[indextr].certificate_id,
                            'single'
                          )
                        "
                      ></vs-button>
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
            <pagination
              :meta="metashare"
              @page-change="handlePageChangeShare"
              class="ml-auto"
            />
            <div v-if="previewModal">
              <vs-popup title="Preview" :active.sync="previewModal">
                <previewTemp :tempDetails="tempDetails"> </previewTemp>
              </vs-popup>
            </div>
          </vs-card>
        </vs-tab>
      </vs-tabs>
    </div>
    <vs-popup
      class="holamundo"
      title="Generate Certificate"
      :active.sync="generateCertificatePopup"
    >
      <!-- shared with staffs name -->
      <span v-if="sharedClient.length != 0">
        <h6 class="mb-2">Already Shared With :</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index15) in sharedClient"
            :key="index15"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}}</p> -->
              <img
                v-if="selectedUser.picture !== null"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>
      <span v-if="sharedStaff.length != 0">
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index15) in sharedStaff"
            :key="index15"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}}</p> -->
              <img
                v-if="selectedUser.picture !== null"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
      </span>
      <span v-if="selectedStaffs.length != 0">
        <h6 class="mb-4">Shared Staffs :</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index1) in selectedStaffs"
            :key="index1"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
              <img
                v-if="selectedUser.picture != ''"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <span @click="closeSelectedUser1(index1)" class="close"
                >&times;</span
              >
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
        <vs-divider />
      </span>

      <!-- shared with students name -->

      <span v-if="selectedStudents.length != 0">
        <h6 class="mb-4">Shared Students :</h6>
        <div class="flex flex-wrap mb-4">
          <div
            class="text-center mr-1"
            v-for="(selectedUser, index2) in selectedStudents"
            :key="index2"
          >
            <div class="selected-names">
              <!-- <p>{{selectedUser.first_name[0]}} {{selectedUser.last_name[0]}}</p> -->
              <img
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <img
                v-if="selectedUser.picture != ''"
                class="person-img rounded-full shadow-md block"
                :src="selectedUser.picture"
              />
              <img
                v-else
                class="person-img rounded-full shadow-md block"
                src="@/assets/images/pages/user-circle-solid.svg"
              />
              <span @click="closeSelectedUser2(index2)" class="close"
                >&times;</span
              >
            </div>
            <p class="name-selected">
              {{ selectedUser.first_name }} {{ selectedUser.last_name }}
            </p>
          </div>
        </div>
        <vs-divider />
      </span>

      <vs-tabs class="cstm_line_tabular_view">
        <vs-tab label="Staffs">
          <div class="tab-text">
            <vs-input
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchStaffBySearch"
              v-model="searchName"
              >Search</vs-input
            >

            <div class="person-list-holder">
              <vs-table
                class="checkbox_removed_vstable cstm_vuexy_table"
                multiple
                v-model="selectedStaffs"
                :data="notShareduserList"
              >
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td style="width: 40px;" :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="person-img rounded-full shadow-md block"
                        :src="data[indextr].picture"
                      />
                      <img
                        v-else
                        class="person-img rounded-full shadow-md block"
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td>
                      <span>
                        {{ data[indextr].first_name }}
                        {{ data[indextr].last_name }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap items-center justify-between mt-4">
                <div>
                  <vs-button
                    v-if="currentPageUser > 1"
                    @click="showBackUser"
                    color="primary"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonUser == true"
                    @click="showMoreUser"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>

        <vs-tab label="Students">
          <div class="tab-text">
            <vs-input
              class="ml-auto mb-4"
              icon-pack="feather"
              icon="icon-search"
              icon-before
              placeholder="Search"
              type="text"
              @input="fetchStudentBySearch"
              v-model="searchName"
              >Search</vs-input
            >

            <div class="person-list-holder">
              <vs-table
                class="checkbox_removed_vstable cstm_vuexy_table"
                multiple
                v-model="selectedStudents"
                :data="notSharedclient"
              >
                <template slot-scope="{ data }">
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td style="width: 40px;" :data="data[indextr].picture">
                      <img
                        v-if="data[indextr].picture != ''"
                        class="person-img rounded-full shadow-md block"
                        :src="data[indextr].picture"
                      />
                      <img
                        v-else
                        class="person-img rounded-full shadow-md block"
                        src="@/assets/images/pages/user-circle-solid.svg"
                      />
                    </vs-td>
                    <vs-td>
                      <span>
                        {{ data[indextr].first_name }}
                        {{ data[indextr].last_name }}
                      </span>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <div class="flex flex-wrap justify-between items-center mt-4">
                <div>
                  <vs-button
                    type="border"
                    v-if="currentPageClient > 1"
                    @click="showBackClient"
                    color="primary"
                    icon-pack="feather"
                    icon="icon-chevron-left"
                  ></vs-button>
                </div>
                <div class="text-right">
                  <vs-button
                    icon-pack="feather"
                    icon="icon-chevron-right"
                    v-if="showButtonClient == true"
                    @click="showMoreClient"
                  ></vs-button>
                </div>
              </div>
            </div>
          </div>
        </vs-tab>
        <div class="text-right mt-4">
          <vs-button
            class="block ml-auto mt-4"
            v-if="checkCertificateGeneratePermission()"
            @click="saveAndGenerate"
            >Generate & Save</vs-button
          >
        </div>
      </vs-tabs>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="false"
        :paginate-elements-by-height="1400"
        filename="Certificate"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a4"
        pdf-orientation="landscape"
        pdf-content-width="100%"
        @progress="onProgress($event)"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasDownloaded="hasGenerated($event)"
        ref="html2Pdf"
        :html-to-pdf-options="html2pdfOption"
      >
        <section slot="pdf-content" v-if="tempDetails.content">
          <pdfInvoicepart
            :content="tempDetails.content"
            :chooseImage="tempDetails.certificate_image_details"
          />
        </section>
      </vue-html2pdf>
    </vs-popup>
    <vs-popup
      class="certificate_preview_popup"
      title="Preview"
      :active.sync="previewModal"
    >
      <previewTemp :tempDetail="tempDetails"> </previewTemp>
    </vs-popup>
    <vs-popup
      class="certificate_preview_popup"
      title="Preview"
      :active.sync="previewCertificateModal"
    >
      <previewTemp :tempCertDetails="tempCertDetails"> </previewTemp>
    </vs-popup>
    <div ref="printcontent" hidden v-if="tempDetails.content">
      <pdfInvoicepart
        :content="tempDetails.content"
        :chooseImage="tempDetails.certificate_image_details"
      />
    </div>
  </div>
</template>

<script>
import {
  fetchUserClint} from '@/api/blog-post.js' 
import { AgGridVue } from 'ag-grid-vue'
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import templateAction from './templateAction'
import generateActions from './generateActions'
import Recipints from './recipints.vue'
import Vue from 'vue'

import html2canvas from 'html2canvas'
import Pagination from '@/components/common/pagination'
import vSelect from 'vue-select'
import previewTemp from './previewTemplate'
import { fetchUserClient } from '@/api/task-project.js'
import {
  fetchtemplateCertificateApi,
  fetchgeneratedCertificateApi,
  saveGenerateApi,
  fetchSharedCertificate,
  pdfDownload,
  imageDownload
} from '@/api/certificate'
import { DeleteMixin } from './mixin/certificatetemplateDelete'
import { shareMixin } from './mixin/certificateShare'
import { blog } from '../post-blogs/mixins/blog'
import pdfInvoicepart from './pdfInvoice'
import VueHtml2pdf from 'vue-html2pdf'
import { PermissionMiddleware } from '@/mixins/middleware/PermissionMiddleware'
import { courseListing } from '@/api/course-builderapi'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import axios from 'axios'

export default {
  mixins: [DeleteMixin, shareMixin, blog, PermissionMiddleware],
  components: {
    previewTemp,
    pdfInvoicepart,
    VueHtml2pdf,
    vSelect,
    Pagination,
    html2canvas,
    DateRangePicker,
    AgGridVue,
    templateAction,
    generateActions,
    Recipints
  },
  beforeMount () {
    this.columnDefs = [
      {
        headerName: '',
        minWidth: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 60,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: 'node.rowIndex + 1'
      },
      {
        headerName: 'Certificate Name',
        field: 'title',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Certificate Description',
        field: 'description',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Actions',
        field: 'fullname',
        filter: true,
        minWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(templateAction),
        cellRendererParams: {
          preview: this.preview,
          editTemplate: this.editTemplate,
          openConfirm: this.openConfirm,
          generate: this.generate
        }
      }
    ]
    this.columnDefs1 = [
      {
        headerName: '',
        minWidth: 60,
        field: 'isSelected',
        filter: false,
        checkboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        headerCheckboxSelection: true
      },
      {
        headerName: '#',
        field: 'row_index',
        filter: false,
        minWidth: 60,
        resizable: true,
        editable: false,
        sortable: false,
        valueGetter: 'node.rowIndex + 1'
      },
      {
        headerName: 'Certificate Name',
        field: 'title',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true
      },
      {
        headerName: 'Certificate Description',
        field: 'description',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: true
      }, 
      {
        headerName: 'Certificate Recipient',
        field: 'description',
        filter: true,
        minWidth: 150,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(Recipints)
      },
      {
        headerName: 'Actions',
        field: 'fullname',
        filter: true,
        minWidth: 100,
        editable: false,
        sortable: false,
        cellRendererFramework: Vue.extend(generateActions),
        cellRendererParams: {
          previewCertificate: this.previewCertificate,
          share: this.share,
          delete: this.openConfirmForCertificate,
          singleImageDownload: this.singleImageDownload,
          singlePdfDownload: this.singlePdfDownload
        }
      }
    ]
  },
  computed: {
    html2pdfOption () {
      return {
        margin: 0,

        filename: 'Certificate.pdf',

        image: {
          type: 'jpeg',
          quality: 0.98
        },

        enableLinks: false,

        html2canvas: {
          scale: 1,
          useCORS: true
        }
      }
    }
  },
  mounted () {
    // this.fetchtemplateCertificate()
  },
  async created () {
    this.staff = parseInt(localStorage.getItem('role_permission')) === 0
    await this.fetchgeneratedCertificate()
    await this.fetchUser()
    await this.fetchClient()
    await this.checkPermissionForCertificate()
    if (this.staff) {
      await this.fetchShared()
      await this.getCourseOptions()
    }
  },
  data () {
    return {
      observerUser: new IntersectionObserver(this.loadMoreUser),
      observerStudent: new IntersectionObserver(this.loadMoreClient),
      clientListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      userListMeta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      sorting_obj: {
        field_type: '',
        attribute: '',
        direction: ''
      },
      rowData: null,
      columnDefs: null,
      columnDefs1:null,
      gridApi: null,
      tabIndex: 0,
      gridOptions: {
        accentedSort: true
      },
      templateGridOptions: {
        accentedSort: true
      },
      certificateGridOptions: {
        accentedSort: true
      },
      defaultColDef: {
        editable: true,
        sortable: true,
        resizable: true,
        suppressMenu: true
        // autoHeight: true
      },
      isRowSelected: false,
      search: '',
      searchName: '',
      searchGen: '',
      searchShare: '',
      notSharedclient: [],
      notShareduserList: [],
      courseOpt: [],
      metashare: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      staff: true,
      filter: {
        student_id: null,
        teacher_id: null,
        certificate_type: null
      },
      observer: new IntersectionObserver(this.loadMoreCourses),
      certificateType: [
        {
          id: 'general',
          value: 'General'
        },
        {
          id: 'course_specific',
          value: 'Course Specific'
        },
        {
          id: 'class_specific',
          value: 'Class Specific'
        }
      ],
      previewModal: false,
      selectedStaffs: [],
      selectedStudents: [],
      generateCertificatePopup: false,
      selectedSharedCertificate: [],
      selectedCertificateTemplate: [],
      selectedGenCertificate: [],
      certificate_template: [],
      rowDataTemplate: [],
      generated_certificate: [],
      customer_id: this.$store.getters.customerId,
      template_generate_id: null,
      tempDetails: '',
      tempCertDetails: '',
      previewCertificateModal: false,
      chooseImage: null,
      sharedClient: '',
      sharedStaff: '',
      certificate_type: null,
      meta: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      meta1: {
        current_page: 1,
        has_next: true,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      query_page: {
        page: 1
      },
      query_page1: {
        page: 1
      },
      sharedList: '',
      dateRange: { startDate: null, endDate: null },
      filterPayload: {
        course_id: null,
        certificate_type: null
      },
      course_list_meta: {
        current_page: 1,
        has_next: false,
        limit: 10,
        next_page_url: '',
        previous_page_url: null,
        total: null
      },
      certificate_ids: [],
      pageLimitSet:5,
      pageLimitGen:5,
      query_page_user: {
        page: 1
      },
      query_page_client: {
        page: 1
      },
    }
  },
  watch: {
    generateCertificatePopup (new_val) {
      if (!new_val) {
        this.searchName = ''
      }
    },
    pageLimitSet () {
      this.handlePageChange(1)
    },
    pageLimitGen () {
      this.handlePageChangeCer(1)
    }
  },
  mounted () {
    this.gridApi = this.gridOptions.api
  },
  methods: {
    fetchUser () {
      fetchUserClint(
        localStorage.getItem('customer_id'),
        'User',
        this.query_page_user
      )
        .then((res) => {  
          this.userList = res.data.data.users_list
          this.userListForAdd = res.data.data.users_list
          this.userListMeta = res.data.data.meta
          
        })
        .catch((e) => {
                
        })
    },
    fetchClient () {
      fetchUserClint(
        localStorage.getItem('customer_id'),
        'Client',
        this.query_page_client
      )
        .then((res) => {  
          this.clientList = res.data.data.users_list
          this.clientListForAdd = res.data.data.users_list
          this.clientListMeta = res.data.data.meta
        })
        .catch((e) => {
                
        })
    },
        async loadMoreUser ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        console.log(this.userListMeta.current_page + 1)
        const payload = {
          source: true
        }
        try {
          const res = await fetchUserClient(
            'User',
            localStorage.getItem('customer_id'),
            { page: this.userListMeta.current_page + 1 },
            payload
          )
          this.userList.push(...res.data.data.users_list)
          this.userList = this.userList.map(user => {
            user.label = `${user.first_name} ${user.last_name}`
            return user
          })
          this.userListMeta = res.data.data.meta
        } catch (e) {}
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenUser () {
      if (this.userListMeta.has_next) {
        await this.$nextTick()
        this.observerUser.observe(this.$refs.load)
      }
    },
    onCloseUser () {
      this.observerUser.disconnect()
    },
    async loadMoreClient ([{ isIntersecting, target }]) {
      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop
        const payload = {
          source: true
        }
        try {
          console.log("first")
          const res = await fetchUserClient(
            'Client',
            localStorage.getItem('customer_id'),
            { page: this.clientListMeta.current_page + 1 },
            payload
          )
          this.clientList.push(...res.data.data.users_list)

          this.clientListMeta = res.data.data.meta
        } catch (e) {}

        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async onOpenClient () {
      if (this.clientListMeta.has_next) {
        console.log("s")
        await this.$nextTick()
        this.observerStudent.observe(this.$refs.loadStudent)
      }
    },
    onCloseClient () {
      this.observerStudent.disconnect()
    },
    async sortFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        console.log()
        if (sortState.length === 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
          const payload = {
            limit:this.pageLimitSet
          }
          this.fetchtemplateCertificate(this.meta.current_page, payload)
        }
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    }, 
    async sortGenFun () {
      try {
        const sortState = this.gridOptions.api.getSortModel()
        console.log()
        if (sortState.length == 0) {
          console.log('No sort active')
        } else {
          this.sorting_obj.field_type = 'system'
          this.sorting_obj.attribute = sortState[0].colId
          this.sorting_obj.direction = sortState[0].sort
          const payload = {
            limit:this.pageLimitGen
          }
          this.fetchgeneratedCertificate(this.meta1.current_page, payload)
        }
      } catch (e) {
      } finally {
        this.$vs.loading.close()
      }
    },
    onGridReady () {
      if (this.tabIndex === 0) {
        this.templateGridOptions.api.sizeColumnsToFit()
      } else if (this.tabIndex === 1) {
        this.certificateGridOptions.api.sizeColumnsToFit()
      }
    },
    paginationPageSize () {
      return this.pageLimitSet
    }, 
    paginationPageSizeGen () {
      return this.pageLimitGen
    },
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data)
      //
      return selectedData
    },
    CellvalueSelectDeselect () {
      this.gridApi = this.gridOptions.api
      const selectedNodes = this.gridApi.getSelectedNodes()
      //
      if (selectedNodes) {
        //
        const selecttedNode = this.gridApi.getSelectedNodes()
        const selectedRows = selecttedNode.map(node => node.data)
        if (selectedRows.length > 1) {
          this.isRowSelected = true
        } else {
          this.isRowSelected = false
        }
      } else {
        this.isRowSelected = false
      }
    },
    async searchFun () {
      this.fetchListBySearch(this)
    },
    fetchListBySearch: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.search,
          limit:vm.pageLimitSet
        }
        vm.fetchtemplateCertificate(vm.meta.current_page, payload)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    async searchFunshare () {
      this.fetchListBySearchShare(this)
    },
    fetchListBySearchShare: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.searchFunshare
        }
        vm.fetchShared(vm.meta.current_page, payload)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    async searchFunGen () {
      this.fetchListBySearchGen(this)
    },
    fetchListBySearchGen: _.debounce(async vm => {
      try {
        const payload = {
          search: vm.searchGen,
          limit:vm.pageLimitGen
        }
        vm.fetchgeneratedCertificate(vm.meta1.current_page, payload)
      } catch (e) {
        console.log(e)
      }
    }, 1500),
    fetchStaffBySearch () {
      this.searchStaff(this)
    },
    fetchStudentBySearch () {
      this.searchStudent(this)
    },
    searchStaff: _.debounce(async vm => {
      try {
        const payload = {
          name: vm.searchName,
          source: true
        }

        const res = await fetchUserClient(
          'User',
          localStorage.getItem('customer_id'),
          vm.query_page,
          payload
        )
        vm.notShareduserList = res.data.data.users_list
        vm.userListMeta = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    searchStudent: _.debounce(async vm => {
      try {
        const payload = {
          name: vm.searchName,
          source: true
        }

        const res = await fetchUserClient(
          'Client',
          localStorage.getItem('customer_id'),
          vm.query_page1,
          payload
        )
        vm.notSharedclient = res.data.data.users_list
        vm.showButtonUser = res.data.data.meta.has_next
      } catch (e) {
        console.log(e)
      }
    }, 350),
    closeSelectedUser1 (index) {
      this.selectedStaffs.splice(index, 1)
    },
    closeSelectedUser2 (index) {
      this.selectedStudents.splice(index, 1)
    },
    async runFilterShare () {
      const payload = {
        ...this.filterPayload,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      }

      await this.fetchShared(this.metashare.current_page, payload)
    },
    async resetFilterShare () {
      this.filterPayload = {
        course_id: null,
        certificate_type: null
      }

      this.dateRange = { startDate: null, endDate: null }

      await this.fetchShared(this.metashare.current_page)
    },
    async onOpen () {
      if (this.course_list_meta.has_next) {
        await this.$nextTick()
        this.observer.observe(this.$refs.load)
      }
    },
    onClose () {
      this.observer.disconnect()
    },
    async loadMoreCourses ([{ isIntersecting, target }]) {
      console.log('Target here --------')
      console.log(target)

      if (isIntersecting) {
        const ul = target.offsetParent
        const scrollTop = target.offsetParent.scrollTop

        try {
          const response = await courseListing(
            localStorage.getItem('customer_id'),
            undefined,
            this.course_list_meta.current_page + 1
          )
          this.courseOpt.push(...response.data.data.courselist)

          this.course_list_meta = response.data.data.meta
        } catch (e) {
          console.log(e)
        }

        console.log('Loaded more')
        await this.$nextTick()
        ul.scrollTop = scrollTop
      }
    },
    async getCourseOptions () {
      try {
        const response = await courseListing(
          localStorage.getItem('customer_id')
        )
        this.courseOpt = response.data.data.courselist
        this.course_list_meta = response.data.data.meta
      } catch (e) {
        console.log(e)
      }
    },
    handlePageChangeShare (page) {
      this.metashare.current_page = page

      const payload = {
        ...this.filterPayload,
        startDate: this.dateRange.startDate,
        endDate: this.dateRange.endDate,
        search: this.searchFunshare
      }
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({
        path:'/pages/certificate-listing',
        query:{page:this.metashare.current_page}
      }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.$router.replace({ path: '/pages/leads', query: queryPayload })
      this.fetchShared(this.meta.current_page, payload)
    },
    async fetchShared (page = 1, payload) {
      const userInfo = JSON.parse(localStorage.getItem('userInfo'))
      const data = await fetchSharedCertificate(page, userInfo.id, payload)
      this.sharedList = data.data.data.certificate_list
      this.metashare = data.data.data.meta
    },
    async bulkImg () {
      if (this.selectedGenCertificate.length > 0) {
        await this.selectedGenCertificate.forEach(element => {
          this.certificate_ids.push(element.certificate_id)
        })
      }
      if (this.selectedSharedCertificate.length > 0) {
        await this.selectedSharedCertificate.forEach(element => {
          this.certificate_ids.push(element.certificate_id)
        })
      }

      const payload = {
        id: this.certificate_ids
      }
      const data = await imageDownload(payload)
      data.data.data.forEach(ele => {
        console.log(ele)
        setTimeout(() => {
          this.downloadItem({ url: ele.url, label: ele.name })
        }, 100)
        // this.downloadItem({'url':ele, 'label':'certificate'})
      })

      // this.fetchgeneratedCertificate()
    },
    async singlePdfDownload (certificate_id) {
      this.certificate_ids[0] = certificate_id
      const payload = {
        id: this.certificate_ids
      }
      const data = await pdfDownload(payload)
      console.log(data)
      this.downloadItem({
        url: data.data.data[0].url,
        label: data.data.data[0].name
      })
      // window.open(data.data.data.url[0], '_blank')
    },
    async singleImageDownload (certificate_id) {
      this.certificate_ids[0] = certificate_id
      const payload = {
        id: this.certificate_ids
      }
      const data = await imageDownload(payload)
      console.log(data)
      this.downloadItem({
        url: data.data.data[0].url,
        label: data.data.data[0].name
      })
      // window.open(data.data.data.url[0], '_blank')
    },
    downloadItem ({ url, label }) {
      axios
        .get(url, { responseType: 'blob' })
        .then(response => {
          const blob = new Blob([response.data], { type: 'mime' })
          // const blob = new Blob([response.data], { type: 'application/pdf' })

          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = `${label}.${
            url.split('.')[url.split('.').length - 1]
          }`
          link.click()
          URL.revokeObjectURL(link.href)
        })
        .catch(console.error)
    },
    async bulkPdf () {
      if (this.selectedGenCertificate.length > 0) {
        await this.selectedGenCertificate.forEach(element => {
          this.certificate_ids.push(element.certificate_id)
        })
      }
      if (this.selectedSharedCertificate.length > 0) {
        await this.selectedSharedCertificate.forEach(element => {
          this.certificate_ids.push(element.certificate_id)
        })
      }
      const payload = {
        id: this.certificate_ids
      }
      const data = await pdfDownload(payload)
      // this.certificate_ids.splice(0,this.certificate_ids.length)
      console.log(data)
      data.data.data.forEach(ele => {
        setTimeout(() => {
          this.downloadItem({ url: ele.url, label: ele.name })
        }, 100)
      })
      // this.downloadItem({'url':data.data.data.url[0], 'label':'file'})
      // this.fetchgeneratedCertificate()
      console.log(this.certificate_ids)
    },
    async printThis (data) {
      this.tempDetails = await data
      const el = this.$refs.printcontent

      console.log(el)

      const options = {
        type: 'dataURL',
        useCORS: true,
        width: window.screen.availWidth,
        height: window.screen.availHeight,
        scrollY: -window.scrollY,

        x: 0
      }
      const printCanvas = await html2canvas(el, options)

      const link = document.createElement('a')
      link.setAttribute('download', 'download.png')
      link.setAttribute(
        'href',
        printCanvas
          .toDataURL('image/png')
          .replace('image/png', 'image/octet-stream')
      )
      link.click()

      console.log('done')
    },
    checkPermissionForCertificate () {
      const role_permission = parseInt(localStorage.getItem('role_permission'))
      if (role_permission === 1) {
        this.schoolAdmin = true
      } else {
        this.schoolAdmin = false
        this.getModulePermission('Certificates')
      }
    },
    addRecord () {
      this.$router
        .replace({ path: '/pages/create-certificates' })
        .catch(() => {})
    },
    handlePageChange (page) {
      this.meta.current_page = page

      const payload = {
        certificate_type: this.certificate_type,
        search: this.search,
        limit:this.pageLimitSet
      }
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({
        path:'/pages/certificate-listing',
        query:{page:this.meta.current_page}
      }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.$router.replace({ path: '/pages/leads', query: queryPayload })
      this.fetchtemplateCertificate(this.meta.current_page, payload)
    },
    handlePageChangeCer (page) {
      this.meta1.current_page = page

      const payload = {
        ...this.filter,
        search: this.searchGen,
        limit:this.pageLimitGen
      }
      /* const pageScroll = document.documentElement.scrollTop
      this.$router.replace({
        path:'/pages/certificate-listing',
        query:{page:this.meta1.current_page}
      }).catch(() => {}).then(() => {
        document.documentElement.scrollTop = pageScroll
      }) */
      // this.$router.replace({ path: '/pages/leads', query: queryPayload })
      this.fetchgeneratedCertificate(this.meta1.current_page, payload)
    },
    async runFiltercer () {
      const payload = {
        ...this.filter,
        limit:this.pageLimitGen
      }

      await this.fetchgeneratedCertificate(this.meta1.current_page, payload)
    },
    async resetFiltercer () {
      this.filter.student_id = null
      this.filter.teacher_id = null
      this.filter.certificate_type = null
      this.searchGen = null
      const payload = {
        limit:this.pageLimitGen
      }

      await this.fetchgeneratedCertificate(this.meta1.current_page, payload)
    },
    async runFilter () {
      const payload = {
        certificate_type: this.certificate_type,
        limit: this.pageLimitSet
      }

      await this.fetchtemplateCertificate(this.meta.current_page, payload)
    },
    async resetFilter () {
      this.certificate_type = null
      this.search = null
      const payload = {
        limit: this.pageLimitSet
      }

      await this.fetchtemplateCertificate(this.meta.current_page, payload)
    },
    onProgress (event) {
      this.percentage = event
      this.showPercentage = true

      if (event === 100) {
        this.showPercentage = false
      }
      //   if(event===100)
    },
    hasGenerated (event) {},
    async generateReport (data) {
      this.tempDetails = await data
      setTimeout(() => {
        this.$refs.html2Pdf.generatePdf()
      }, 1000)
    },
    preview (data) {
      this.previewModal = true
      this.tempDetails = data
    },
    previewCertificate (data) {
      this.previewCertificateModal = true
      this.tempCertDetails = data
    },
    generate (template) {
      this.generateCertificatePopup = true
      this.template_generate_id = template.certificate_template_id
      this.Certificate_title = template.title
      this.certificate_description = template.description
      this.content = template.content
      this.courseSpecific = template.is_course_specific === true ? 1 : 0
      this.chooseImage =
        template.certificate_image_details.certificate_image_id
      this.sharedClient = template.shared_client_user
      this.sharedStaff = template.shared_user
      if (this.sharedStaff.length > 0) {
        this.notShareduserList = this.userList
        this.sharedStaff.forEach(element => {
          this.notShareduserList = this.notShareduserList.filter(
            item => item.id != element.id
          )
        })
      } else {
        this.notShareduserList = this.userList
      }
      if (this.sharedClient.length > 0) {
        this.notSharedclient = this.clientListForAdd
        this.sharedClient.forEach(element => {
          this.notSharedclient = this.notSharedclient.filter(
            item => item.client_users_id != element.id
          )
        })
      } else {
        this.notSharedclient = this.clientListForAdd
      }
    },
    async saveAndGenerate () {
      const clientNuser = []

      if (this.selectedStudents.length > 0) {
        this.selectedStudents = this.selectedStudents.map(ele => {
          const container = {}
          container.to_user_type = 2
          container.to_user_id = ele.client_users_id
          return container
        })
        clientNuser.push(this.selectedStudents)
      }

      if (this.selectedStaffs.length > 0) {
        this.selectedStaffs = this.selectedStaffs.map(ele => {
          const container1 = {}
          container1.to_user_type = 1
          container1.to_user_id = ele.id
          return container1
        })
        clientNuser.push(this.selectedStaffs)
      }
      const payload = {
        title: this.Certificate_title,
        description: this.certificate_description,
        content: this.content,
        type: 0,
        is_shared: 1,
        template_id: this.template_generate_id,
        userArray: clientNuser.flat(2),
        certificate_image_id: this.chooseImage
      }
      const data = await saveGenerateApi(payload, this.customer_id)
      this.generateCertificatePopup = false
      this.selectedStudents = []
      this.selectedStaffs = []
      this.$vs.notify({
        title: 'Success',
        text: 'Certificate generated successfully',
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'success',
        time: 2000
      })
      this.fetchtemplateCertificate()
    },
    editTemplate (editingObject) {
      this.$router.push({
        name: 'create-certificates',
        params: {
          editing_object: editingObject
        }
      })
    },
    async fetchtemplateCertificate (page = 1, payload) {
      if (!payload) {
        payload = {
          limit:this.pageLimitSet
        }
      }
      const data = await fetchtemplateCertificateApi(
        page,
        this.customer_id,
        payload,
        this.sorting_obj
      )
      this.certificate_template = data.data.data.certificate_template_list
      this.rowDataTemplate = this.certificate_template
      this.meta = data.data.data.meta
    },
    async fetchgeneratedCertificate (page = 1, payload) {
      if (!payload) {
        payload = {
          limit:this.pageLimitGen
        }
      }
      const data = await fetchgeneratedCertificateApi(
        page,
        this.customer_id,
        payload,
        this.sorting_obj
      )
      this.generated_certificate = data.data.data.certificate_list
      this.meta1 = data.data.data.meta
    }
  }
}
</script>

<style>
.filter-holder {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  /* width: calc(100% - 220px); */
}
.filter-holder .filter-holder-col {
  width: 22%;
}
.filter-holder .filter-holder-col:last-child {
  width: 12%;
}

@media (max-width: 991px) {
  .filter-holder .filter-holder-col {
    width: 50%;
  }
  .filter-holder .filter-holder-col:last-child {
    width: 15%;
  }
}
@media (max-width: 600px) {
  .filter-holder .filter-holder-col {
    width: 100%;
  }
  .filter-holder .filter-holder-col:last-child {
    width: 30%;
  }
}
</style>
